import {
  LessonsType,
  RoomsType,
  ExaminationItemArray,
  ExaminationItem,
  ExaminationItemResult
} from './utils';

export enum RemoteEduPoints {
  GET_ROOMS = 'remote-edu/rooms/',
  GET_LESSONS = 'remote-edu/lessons/',
  GET_TESTS = 'remote-edu/tests/',
  GET_RESULTS = 'remote-edu/final-results/get',
  POST_TESTS = 'remote-edu/test-result/create',
  POST_EXAMINATION_ITEM = 'remote-edu/test-results/create',
  GET_EXAMINATION_LIST = 'remote-edu/tests/get',
  GET_EXAMINATION_ITEM = 'remote-edu/test/get',
  GET_EXAMINATION_ITEM_RESULT = 'remote-edu/final-result/get',
  GET_SFERUM_WEBINARS = 'sferum/get/calls/',
}

export interface ResponseType {
  err_code: string;
  success: boolean;
  token: string;
}

export interface RoomsResponseType extends ResponseType {
  data: RoomsType;
}

export interface LessonsResponseType extends ResponseType {
  data: LessonsType;
}

export interface ExaminationsResponseType extends ResponseType {
  data: ExaminationItemArray;
}

export interface ExaminationResponseType extends ResponseType {
  data: ExaminationItem;
}

export interface ExaminationResultResponseType extends ResponseType {
  data: Array<ExaminationItemResult>;
}



// WEBPACK FOOTER //
// ./src/services/api/remoteedu/types.ts